module.exports = __webpack_public_path__ + "static/media/slider-minimal-agency-slide-02-image-01.fa1f0e2e.jpg";